<h3 mat-dialog-title>{{ title }}</h3>

<mat-dialog-content>{{ message }}</mat-dialog-content>
<br />

<mat-dialog-content [formGroup]="form">
  <mat-form-field style="width: 100%; font-size: 1.25rem">
    <mat-label>{{ inputLabel }}</mat-label>
    <textarea matInput matTextareaAutosize formControlName="inputField"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <markant-button class="blue button" (click)="cancel()">Abbrechen</markant-button>
  <div style="flex-grow: 1"></div>
  <markant-button class="primary pink button" (click)="submit()">Absenden</markant-button>
</mat-dialog-actions>
